const blogList = document.querySelector('.blog-list');

if (blogList) {
  const urlParams = ['years', 'locations', 'pageNumber'];

  const getExtraFormDataInput = (parent) => ({
    moduleIndex: parent.querySelector('[data-k]').value,
    years: getCheckedData(parent, 'years'),
    locations: getCheckedData(parent, 'locations'),
    id: localData.id,
  });

  // Filter click
  attachEvent('.blog-list .mod-filter .dropdown__list-item input', 'click', (ev) => {
    const parent = ev.target.closest('.blog-list');
    const dataPageNumber = parent.querySelector('[data-page-number]');
    if (dataPageNumber) {
      dataPageNumber.setAttribute('data-page-number', 1);
    }

    axiosGetPaginateAndFilteredPosts(parent, 1, urlParams, getExtraFormDataInput(parent));
  });

  // Pagination
  attachEvent('.blog-list .blog-list__load-more', 'click', (ev) => {
    const parent = ev.target.closest('.blog-list');
    const dataPageNumber = ev.target.closest('[data-page-number]');
    const currentPage = parseInt(dataPageNumber?.getAttribute('data-page-number'), 10) || 1;
    const nextPage = currentPage + 1;
    dataPageNumber.setAttribute('data-page-number', nextPage);

    axiosGetPaginateAndFilteredPosts(parent, nextPage, urlParams, getExtraFormDataInput(parent), false);
  });
}
